<template>
    <div class="pd20">
        <div class="main">
            <!-- list 规则 rules -->
            <div class="el-card pd20 list-box ">
                <el-table :data="dimensions_list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="100" label="序号"></el-table-column>
                    <el-table-column prop="mark" label="编码" width="100"></el-table-column>
                    <el-table-column prop="name" label="维度名称"></el-table-column>
                    <el-table-column  label="计分方式">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.score_type" placeholder="请选择">
                                <el-option label="同一维度下所有试题平均分" :value="0">同一维度下所有试题平均分</el-option>
                                <el-option label="同一维度下所有试题得分之和" :value="1">同一维度下所有试题得分之和</el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="评分">
                        <template slot-scope="scope">
                            <input v-model="scope.row.score" placeholder="请输入评分" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--  -->
        <div class="main">
            <!-- 设置公式列表 -->
            <!-- list -->
            <div class="el-card pd20 list-box formula-box">
                <el-table :data="formula_list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="100" label="序号"></el-table-column>
                    <el-table-column prop="alias_name" label="编码" width="100"></el-table-column>
                    <el-table-column  label="名称" >
                        <template slot-scope="scope"  >
                            <input v-if="(formula_index == scope.$index) && formula_input_show" type="text" placeholder="请输入公式名称"  v-model="scope.row.name"  />
                            <div v-else>{{scope.row.name}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="公式(C语言语法)">
                        <template slot-scope="scope"  >
                            <input v-if="(formula_index == scope.$index) && formula_input_show" type="text" placeholder="请输入公式"  v-model="scope.row.formula"  />
                            <div v-else>{{scope.row.formula}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_score" label="评分" width="100"></el-table-column>
                    <el-table-column label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button type="primary" v-if="(formula_index == scope.$index) && formula_input_show" size="mini" icon="el-icon-check" @click="formula_input_show=false"  circle></el-button>
                            <el-button type="primary" v-else size="mini" icon="el-icon-edit" @click="formulaEdit(scope.$index, scope.row,$event)"  circle></el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeHandle(scope.$index, scope.row)" circle></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="formula_list.push({name:'',formula:'',eid:$route.query.id})" circle></el-button>
            <el-button type="primary" class="addBtn saveBtn" size="mini" icon="el-icon-circle-check" @click="submitFormulaHandle">保存更改</el-button>
            <!-- 分页 -->
            <!-- <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination> -->
            <!--  -->
            <div class="pages-box"></div>
        </div>
    </div>
</template>

<script>
import { formulaList,formulaAdd,formulaDel } from "@/api/measurement";
export default {
    data() {
        return{
            dimensions_list: [],
            pages: {},
            formula_list:[],
            formula_index:null,
            formula_input_show:false
        }
    },
    methods:{
        // 删除公式
        removeHandle(index,row){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(row.id){
                    formulaDel({
                        id:row.id
                    }).then((data)=>{
                        if(data.error >0){
                            this.$message(data.msg);
                            return
                        }
                        this.$notify({
                            title: '成功',
                            message: '删除成功',
                            type: 'success'
                        });
                        // 删除成功重新调用接口刷新数据
                        formulaList({eid:this.$route.query.id});
                    });
                }
                this.formula_list.splice(index, 1);
            }).catch();
            
        },
        // 提交公共更改或添加
        submitFormulaHandle(){
            this.formula_input_show = false;
            formulaAdd({
                list:this.formula_list,
                dimensions:this.dimensions_list
            }).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.$notify({
                    title: '成功',
                    message: '保存成功',
                    type: 'success'
                });
                this.pullData();
            })
        },
        formulaEdit(index,row){
            this.formula_index = index;
            this.formula_input_show = true;
        },
        pullData(){
            this.$showLoading();
            formulaList({
                eid:this.$route.query.id
            }).then((data)=>{
                this.pages = data.pager;
                // 规则数组
                this.dimensions_list = data.dimensions;
                // 公式数组
                this.formula_list = data.list;
                this.$hideLoading();
            }).catch(()=>{
                this.$hideLoading();
            });

        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.addBtn.saveBtn{
    left: 30px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.formula-box{
    margin-top: 15px;
}
  .list-box table{
    input{
        background-color: #ffffff !important;
        color: #fe893c !important;
        padding: 5px 8px;
        margin-left: 10px;
        border-radius: 5px;
        width: 60%;
    }
  }
</style>
